/**
 * i18nextの文字列定義で用いるnamespace
 */
export var translationNamespace = 'uikit';
/**
 * i18nextによる翻訳に用いる文字列リソース。
 *
 * - Key: 中学、先生向けのテキスト。
 * - Value: 小学生向けテキスト。
 * - 出し分けをしないものも文字列リソースの一覧性のためにここに定義する。
 * - 文言の決定ではライティングルールを参照する。
 *     - https://docs.google.com/spreadsheets/d/108gLSMwYavG6hUB9-i7oX94QOTMRCy-jdaKiN3AnJvU/edit#gid=957687617
 */
export var translationResources = {
    // 複数の箇所で使われている単語
    キャンセル: 'キャンセル',
    選ぶ: 'えらぶ',
    確認: 'かくにん',
    検索: 'けんさく',
    クリア: 'クリア',
    OK: 'OK',
    通信できませんでした: 'つうしんできませんでした',
    エラーがおきました: 'エラーがおきました',
    スマイルドリル: 'スマイルドリル',
    // ユーザー選択ダイアログ
    ユーザーを選ぶ: 'ユーザーをえらぶ',
    選んだユーザー: 'えらんだユーザー',
    '選べるユーザーがいません。': 'えらべるユーザーがいません。',
    全て選ぶ: 'すべてえらぶ',
    全て解除: 'すべてかいじょ',
    // ノート選択ダイアログ
    ノートを選ぶ: 'ノートをえらぶ',
    '選べるノートがありません。': 'えらべるノートがありません。',
    開く: '開く',
    '読み込みに失敗しました。': '読みこみにしっぱいしました。',
    ノート名: 'ノート名',
    ノート名を入力: 'ノート名を入力',
    作成月: 'さくせい月',
    から: 'から',
    まで: 'まで',
    '作成 LL月dd日 HH:mm': 'さくせい LL月dd日 HH:mm',
    '作成 yyyy年LL月dd日': 'さくせい yyyy年LL月dd日',
    '更新 LL月dd日 HH:mm': 'こうしん LL月dd日 HH:mm',
    '更新 yyyy年LL月dd日': 'こうしん yyyy年LL月dd日',
    作成者: 'さくせいしゃ',
    所有者名を表示する: 'なまえをひょうじする',
    課題: 'かだい',
    全て: 'すべて',
    設定されている: 'せっていされている',
    設定されていない: 'せっていされていない',
    '選んだノート %s件': 'えらんだノート %sけん',
    旗のついたページを表示する: 'はたのついたページをひょうじする',
    // ワーク選択ダイアログ + ドリルの教科周りの文言全般
    ワークメーカー: 'ワークメーカー',
    ワーク名: 'ワーク名',
    ワーク名を入力: 'ワーク名を入力',
    ワークを選ぶ: 'ワークを選ぶ',
    選んだワーク: '選んだワーク',
    '選べるワークがありません。': '選べるワークがありません。',
    'テンプレートを準備中です。': 'テンプレートを準備中です。',
    'LL月dd日 HH:mm': 'LL月dd日 HH:mm',
    yyyy年LL月dd日: 'yyyy年LL月dd日',
    教科: '教科',
    国語: '国語',
    算数: '算数',
    理科: '理科',
    社会: '社会',
    英語: '英語',
    英語リスニング: '英語リスニング',
    数学: '数学',
    地理: '地理',
    歴史: '歴史',
    公民: '公民',
    実技: '実技',
    技術: '技術',
    美術: '美術',
    家庭: '家庭',
    保体: '保体',
    音楽: '音楽',
    復習国語: '復習国語',
    復習算数: '復習算数',
    小国: '小国',
    小算: '小算',
    小学国語: '小学国語',
    小学英語: '小学英語',
    小学理科: '小学理科',
    小学社会: '小学社会',
    中学国語: '中学国語',
    中学英語: '中学英語',
    中学理科: '中学理科',
    問題: '問題',
    リスニング練習: 'リスニング練習',
    漢字: '漢字',
    かな: 'かな',
    漢字練習: '漢字練習',
    ひらがな: 'ひらがな',
    '教科書出版社設定が変更されたため、': '教科書出版社設定が変更されたため、',
    '教科書改訂前の教材を使っているため、': '教科書改訂前の教材を使っているため、',
    '以下のワークは配付できません。': '以下のワークは配付できません。',
    // DatePicker
    // PickerConfigで定義される表示形式は本ファイルの管理下にできていない。
    'yyyy/MM/dd': 'yyyy/MM/dd',
    'HH:mm': 'HH:mm',
    yyyy年MM月: 'yyyy年MM月',
    '%04d年': '%04d年',
    '%d月': '%d月',
    日付: '日づけ',
    時刻: '時こく',
    '○○○○年△△月': '○○○○年△△月',
    // ページネーション
    '%d / %d': '%d / %d',
    // useAuthCheck
    '時間がたったので、もう一度ログインしてください。': '時間がたったので、もう一度ログインしてください。',
    // 情報活用課題選択ダイアログ
    テーマを選ぶ: 'テーマをえらぶ',
    コースを選ぶ: 'コースをえらぶ',
    // ファイル選択ダイアログ
    '選べるファイルがありません。': 'えらべるファイルがありません。',
    ファイル名: 'ファイル名',
    ファイル名を入力: 'ファイル名を入力',
    // 画像選択ダイアログ
    画像を選ぶ: '画ぞうをえらぶ',
    上へ: '上へ',
    イラスト: 'イラスト',
    アップロード: 'アップロード',
    カメラ: 'カメラ',
    回転: '回転',
    変更: 'へんこう',
    ここにファイルをドラッグ: 'ここにファイルをドラッグ',
    または: 'または',
    ファイルを選ぶ: 'ファイルをえらぶ',
    撮り直す: 'とり直す',
    カメラがブロックされています: 'カメラがブロックされています',
    '縦横比が1：10より大きい画像は使用できません。': 'じゅうおうひが1：10より大きい画ぞうは使用できません。',
    // QRコード読み取り機能
    QRコードを読み取る: 'QRコードを読み取る',
    コピー: 'コピー',
    'テキストをコピーしました。': 'テキストをコピーしました。',
    リンクを開く: 'リンクを開く',
    'タブレットを静かに動かしQRコードがきれいにうつるところまで近づけたり遠ざけたりします。': 'タブレットをしずかに動かしQRコードがきれいにうつるところまで近づけたり遠ざけたりします。',
    閉じる: 'とじる',
    詳細: 'しょうさい',
    '●ピントを合わせるには': '●ピントを合わせるには',
    '・タブレットを持ち、画面の真ん中にQRコードがおさまるようにしましょう。': '・タブレットを持ち、画面の真ん中にQRコードがおさまるようにしましょう。',
    '・タブレットを静かに動かしQRコードがきれいにうつるところまで近づけたり遠ざけたりしましょう。': '・タブレットをしずかに動かしQRコードがきれいにうつるところまで近づけたり遠ざけたりしましょう。',
    '●読み取れない場合': '●読み取れない場合',
    '・QRコードを拡大して印刷した紙面を用意するか、ディスプレイに拡大して映したものを読み取るなどしてください。': '・QRコードをかくだいしていんさつした紙面を用意するか、ディスプレイにかくだいしてうつしたものを読み取るなどしてください。',
    '※QRコードの大きさによっては、カメラでうまく読み取れない場合があります。': '※QRコードの大きさによっては、カメラでうまく読み取れない場合があります。',
    // ドリルサムネイル
    '教材が選ばれていません。': 'きょうざいがえらばれていません。',
    'サムネイルでエラーが発生しました。': 'サムネイルでエラーが発生しました。',
    // ワークサムネイル
    'ワークが選ばれていません。': 'ワークが選ばれていません。',
    'のワークには古い教材が含まれています。': 'のワークには古い教材がふくまれています。',
    '設定されている問題を確認して、やりなおしてください。': 'せっていされている問題をかくにんして、やりなおしてください。',
    エラー: 'エラー',
    ワーク一覧画面を開く: 'ワーク一覧画面を開く',
};
